import React from 'react'
import { Chip } from '@mui/material'
import DataGrid from '../../../../../table/DataGrid'
import IconTooltipButton from '../../../../../button/IconTooltipButton'
import ChipRating from '../Ratings/ChipRating'

const List = ({ isLoading, list, permissions, onAction }) => {
  const columnsTable = [
    {
      show: true,
      key: 'primary',
      align: 'left',
      hide: false,
      width: 100,
      label: 'Name'
    },
    {
      show: true,
      key: 'rating',
      align: 'left',
      hide: false,
      width: 200,
      label: 'rating'
    },
    {
      show: true,
      key: 'actions',
      align: 'center',
      hide: false,
      width: 50,
      label: 'actions'
    }
  ]

  return (
    <DataGrid
      id='special-circumstances-periodical-report'
      showSetting={false}
      rowsPerPage={list?.length || 10}
      rows={list.map((row) => {
        return {
          ...row,
          rating: (
            <div className='flex flex-col py-1 max-w-200px gap-1'>
              {row?.ratings?.map((item, index) => (
                <ChipRating key={index} {...item} />
              ))}
            </div>
          ),
          primary: (
            <div className='py-1'>
              <p>{row.name}</p>
              <p className='text-xs text-muted-foreground opacity-50'>{row.description}</p>
            </div>
          ),
          actions: (
            <div>
              <IconTooltipButton title='Preview' icon='expand-alt' onClick={() => onAction('preview', row)} />
              {permissions['updated'] && (
                <IconTooltipButton
                  title='Edit'
                  icon={['fas', 'edit']}
                  onClick={() => onAction('edit', row)}
                />
              )}
              {permissions['deleted'] && (
                <IconTooltipButton
                  title='Delete'
                  icon={['fas', 'trash-alt']}
                  onClick={() => onAction('delete', row)}
                />
              )}
            </div>
          )
        }
      })}
      loading={isLoading}
      columns={columnsTable}
      labelNoRows="You don't have any special circumstances yet"
    />
  )
}

export default List
